export default __webpack_public_path__ + "static/media/pictogramBeaconDebtConsolidation48.a42494bb.svg";